export var defaultRenderLabel = function (item) { return item.label; };
